import React from "react";

// Shows long names on one line with an ellipsis; the full text appears on hover (title)
export default function TruncatedText({ text, className = "", maxWidthClass = "max-w-[14rem]" }) {
  const value = text ?? "";
  return (
    <span className={`block truncate ${maxWidthClass} ${className}`} title={value}>
      {value}
    </span>
  );
}
